export default __webpack_public_path__ + "static/media/Foyer_V.4.21339a44.png";